






import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import GoogleMapsLoader from 'google-maps';

@Component({})
export default class Map extends Vue {
  @State(state => state.app.mapShowed) mapShowed!: boolean;

  $refs!: {
    map: HTMLElement;
    wrap: HTMLElement;
  }

  mounted() {
    GoogleMapsLoader.KEY = 'AIzaSyBe6LV-dX9i63jn-4wuxLSySjr4bkwTKqI';
    GoogleMapsLoader.VERSION = 'weekly';
    GoogleMapsLoader.load((google: any) => {
      this.initMap(google);
    });
  }

  initMap(google: any) {
    let map: any;
    var latlngs = [
      new google.maps.LatLng(50.055837, 36.318136),
      new google.maps.LatLng(50.025399, 36.336291),
      new google.maps.LatLng(50.027554, 36.331286),
      new google.maps.LatLng(50.029330, 36.328127),
      new google.maps.LatLng(50.018011, 36.298567),
      new google.maps.LatLng(50.050651, 36.319631),
      new google.maps.LatLng(50.045964, 36.315412),
      new google.maps.LatLng(50.043606, 36.321261),
      new google.maps.LatLng(50.044016, 36.326121),
      new google.maps.LatLng(50.045376, 36.327413),
      new google.maps.LatLng(50.040343, 36.310721)
    ];
  
    var mapCenter = new google.maps.LatLng(50.047426, 36.325099);
    var styledMapType = new google.maps.StyledMapType([
      { "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#0d0b0b" }, { "lightness": 45 }] },
      { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#0d0b0b" }, { "lightness": 16 }] },
      { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
      { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 20 }] },
      { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 17 }, { "weight": 1.2 }] },
      { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 20 }] },
      { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 21 }] },
      { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 13 }] },
      { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 29 }, { "weight": 0.2 }] },
      { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 13 }] },
      { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 13 }] },
      { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#0d0b0b" }, { "lightness": 19 }] },
      { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#1d2f3b" }, { "lightness": 5 }] }
    ]);

    map = new google.maps.Map(this.$refs.map, {
      center: latlngs[0],
      zoom: (window.innerWidth < 500)? 14 : 15,
      gestureHandling: 'cooperative',
      disableDefaultUI: false,
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: true
    });

    var markerIcon = '/map/Map-icon-main.png';
    var markerIcon2 = '/map/Map-icon.png';


    var marker1 = new google.maps.Marker({
      position: latlngs[0],
      icon: markerIcon,
    });

    var infowindow1 = new google.maps.InfoWindow({
      content: "<div class='map-info'>Green Hills</div>",
      position: latlngs[0],
    });

    marker1.setMap(map);
    infowindow1.open(map, marker1);

    var markers = [],
      infowindows = [],
      infowindowsTexts = [
        'Метро<br>"Героев Труда"',
        'ТРЦ "Дафи',
        'ТРЦ Караван',
        'Журавлевский<br>гидропарк',
        'Ресторан-курорт<br>"Дубровський"',
        'Остановка<br>транспорта',
        'Дет. сад',
        'Школа №96',
        'Супермаркет', 'Супермаркет'];

    for (var i = 1; i < latlngs.length; i++) {
      var myLatlng = latlngs[i];

      markers[i] = new google.maps.Marker({
        position: myLatlng,
        icon: markerIcon2,
      });

      markers[i].setMap(map);

      infowindows[i] = new google.maps.InfoWindow({
        content: "<div class='map-info'>" + infowindowsTexts[i - 1] + "</div>",
        position: myLatlng,
      });

      infowindows[i].open(map, markers[i])
    }

    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');

    setTimeout(function () {
      map.setCenter(mapCenter)
    }, 500);
  }
}
